import * as _ from "lodash-es";
import Campus, {CampusesById} from "../types/Campus";

/**
 * Given a collection (list or record) of campuses, groups them by region.
 *
 * Also sorts the regions, and sorts the campuses within each region by city.
 *
 * Example:
 * 		groupCampusesByRegion([
 * 			{city: "San Diego", region: "California"},
 * 			{city: "Irvine", region: "California"},
 * 			{city: "Princeton", region: "New Jersey"},
 *   ]) => {
 * 			"California": [
 * 				{city: "Irvine", region: "California"},
 * 				{city: "San Diego", region: "California"},
 * 			],
 * 			"New Jersey": [
 * 				{city: "Princeton", region: "New Jersey"},
 * 			],
 * 		}
 */
const groupCampusesByRegion = (
	campuses: Campus[] | CampusesById
): Record<string, Campus[]> => {
	const campusesSortedByRegion = _.sortBy(campuses, "region", "city");
	const campusesByRegion = _.groupBy(
		campusesSortedByRegion,
		(campus: Campus) => campus.region
	);
	return campusesByRegion as Record<string, Campus[]>;
};

export default groupCampusesByRegion;
